<template>
  <hel-module title="战略目标进度" :class="scope.clsPrefix" v-loading="loading">
    <div class="progress-container">
      <div class="progress-item" v-for="(item, index) in progressItems" :key="index">
        <div class="item-header">
          <span class="item-name">{{ item.name }}</span>
        </div>
        <div class="progress-bar-wrapper">
          <div class="progress-bar">
            <div :class="['bar-fill', item.statusClass]" :style="{ width: item.percent + '%' }"></div>
          </div>
        </div>
        <div class="item-header">
          <span class="item-value">{{ item.percent }}%</span>
          <span :class="['item-status', item.statusClass]">{{ item.status }}</span>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
export default {
  name: 'StrategyProgress',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-strategy-progress'
      },
      // 2025年9月 mock 数据（战略目标进度全部 90%+）
      progressItems: [
        { name: '库存域', percent: 93, status: '领先', statusClass: 'status-leading' },
        { name: '制造域', percent: 98, status: '领先', statusClass: 'status-leading' },
        { name: '研发域', percent: 96, status: '领先', statusClass: 'status-leading' },
        { name: '供应域', percent: 91, status: '领先', statusClass: 'status-leading' },
        { name: '营销域', percent: 94, status: '领先', statusClass: 'status-leading' }
      ]
    }
  },
  created() {},
  mounted() {
    this.fetchStrategicGoals() // 2025-09-02 改用 mock 数据，注释接口调用
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case '领先':
          return 'status-leading'
        case '正常':
          return 'status-normal'
        case '预警':
          return 'status-warning'
        default:
          return 'status-normal'
      }
    },
    async fetchStrategicGoals() {
      this.loading = true
      try {
        const now = new Date()
        const year = now.getFullYear().toString()
        const month = (now.getMonth()).toString()
        // 'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/strategicGoals',
        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/erp/strategicGoals',
          {
            secret: '9k0NVP',
            paramList: [
              { paramName: 'year', paramValue: year },
              { paramName: 'month', paramValue: month }
            ]
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('战略目标进度接口返回:', response.data)

        if (response.data.code === 200 && response.data.data.length > 0) {
          this.progressItems = response.data.data.map((item) => ({
            name: item.domain_name,
            percent: item.progress,
            status: item.status,
            statusClass: this.getStatusClass(item.status)
          }))
        }
      } catch (error) {
        console.error('获取战略目标进度失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-strategy-progress";
.#{$class-prefix} {
  .progress-container {
    height: 100%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .progress-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  .item-header {
    flex-shrink: 0;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
  }
  .item-name {
    font-family: PingFangSC-Medium;
font-weight: 600;
font-size: 12px;
color: #333333;
  }
  .item-value {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
  .item-status {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    padding: 2px 8px;
    border-radius: 10px;
    &.status-leading {
      color: #73B950;
      // background-image: radial-gradient(92% -2%, #7A63FE 0%, #4A64F4 32%, #4D7EFD 84%, #4EB9FF 100%);
      background: #F1F8ED;
    }
    &.status-normal {
      color: #4A5FF3;
      background: #EDF1FB;
    }
    &.status-warning {
      color: #faad14;
      background: #fffbe6;
    }
    &.status-danger {
      color: #F44F4F;
      background: #FEEDED;
    }
  }
  .progress-bar-wrapper {
    // width: 100%;
    flex: 1;
    margin: 0 8px;
  }
  .progress-bar {
    width: 100%;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }
  .bar-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.5s ease;
    &.status-leading {
      background: linear-gradient(90deg, #4EB9FF 0%, #7A63FE 100%);
    }
    &.status-normal {
      background: linear-gradient(90deg, #4EB9FF 0%, #7A63FE 100%);
    }
    &.status-warning {
      background: linear-gradient(90deg, #4EB9FF 0%, #7A63FE 100%);
    }
    &.status-danger {
      background: linear-gradient(90deg, #4EB9FF 0%, #7A63FE 100%);
    }
  }
}
</style>
